export const landingPageTours = {
  'landing-navigation': {
    id: 'landing-navigation',
    title: 'Welcome to SOMO Academia',
    category: 'landing',
    steps: [
      {
        target: '.sticky-navigation',
        content: 'Navigate between sections with our smart menu that follows you as you scroll.',
        placement: 'bottom',
        disableBeacon: true,
        styles: {
          tooltip: {
            width: '320px'
          }
        }
      },
      {
        target: '.progress-indicator',
        content: 'This progress bar shows how far you\'ve scrolled through the page.',
        placement: 'left',
        offset: 10
      },
      {
        target: '.theme-toggle',
        content: 'Switch between light and dark themes to match your preference.',
        placement: 'bottom',
        offset: 10
      },
      {
        target: '.cta-button',
        content: 'Ready to get started? Click here to begin your academic journey.',
        placement: 'top',
        offset: 10
      }
    ],
    conditions: {
      delay: 3000,
      firstVisit: true,
      path: '/'
    }
  },

  'landing-features': {
    id: 'landing-features',
    title: 'Discover Our Features',
    category: 'landing',
    steps: [
      {
        target: '.solution-overview',
        content: 'Learn about our comprehensive academic solutions.',
        placement: 'top'
      },
      {
        target: '.process-section',
        content: 'See how our simple 3-step process works.',
        placement: 'top'
      },
      {
        target: '.pricing-section',
        content: 'Choose from our flexible pricing options.',
        placement: 'top'
      },
      {
        target: '.testimonials-section',
        content: 'Read what our satisfied students have to say.',
        placement: 'top'
      }
    ],
    conditions: {
      delay: 5000,
      elementVisible: '.solution-overview',
      path: '/'
    }
  },

  'mobile-navigation': {
    id: 'mobile-navigation',
    title: 'Mobile Navigation',
    category: 'mobile',
    steps: [
      {
        target: '.mobile-bottom-nav',
        content: 'Use this bottom navigation for easy mobile browsing.',
        placement: 'top'
      },
      {
        target: '.mobile-menu-toggle',
        content: 'Tap here to open the full navigation menu.',
        placement: 'top'
      },
      {
        target: '.floating-action-buttons',
        content: 'Quick access to contact options and scroll to top.',
        placement: 'left'
      }
    ],
    conditions: {
      delay: 2000,
      elementVisible: '.mobile-bottom-nav',
      path: '/'
    }
  }
};